// extracted by mini-css-extract-plugin
var _1 = "EmailTableRowActions-moduleEmailTableRowActions__PiBJy TableRowActions-moduleTableRowActions__fFC5b TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
export { _1 as "EmailTableRowActions" }
